(function ($) {

    // Sticky header for packages comparison table
    function checkStickyHeader() {
        $('.offer-30-packages-comparison table thead').each(function() {
            const $thead = $(this);
            const $table = $thead.closest('table');
            const tableTop = $table.offset().top;
            const scrollTop = $(window).scrollTop();
            const siteHeaderHeight = 82;

            if (scrollTop + siteHeaderHeight > tableTop) {
                $thead.addClass('is-stuck');
            } else {
                $thead.removeClass('is-stuck');
            }
        });
    }

    $(window).on('scroll', checkStickyHeader);
    checkStickyHeader();

    // Expand button
    $('.expand-button').on('click', function(){
        $('.offer-30-packages-comparison').removeClass('collapsed');
    });

    // On mobile, "Wybierz" switches the matching package view in the pricing block (offer-35).
    $('.offer-30-packages-comparison .package-cta-button[data-package-name]').on('click', function (e) {
        if (window.innerWidth >= 1200) return;

        const packageName = ($(this).data('packageName') || '').toString().trim().toLowerCase();
        if (!packageName) return;

        // Partial/bidirectional match: pill labels may carry extra decoration
        // (e.g. "Max ⭐") that the comparison table's plain heading doesn't have.
        const $offer35 = $('.offer-35').first();
        const $pill = $offer35.find('.offer-35__select.package li').filter(function () {
            const pillName = $(this).text().trim().toLowerCase();
            return pillName.indexOf(packageName) !== -1 || packageName.indexOf(pillName) !== -1;
        }).first();

        if (!$pill.length) return;

        e.preventDefault();
        $pill.trigger('click');
        $offer35[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    // Close tooltips on body click
    $('body').on('click', function (e) {
        if ($(e.target).parents().hasClass('property') || $(e.target).hasClass('property')) {
            e.stopPropagation();
            return;
        }
        $('.tooltip-open').remove();
        $('.tooltip').removeClass('open');
    });

    // Escape key closes modal
    $(document).on("keydown", (event) => {
        if (event.key === "Escape" || event.keyCode === 27) {
            closeModal();
        }
    });

    // Video modal
    $('#offer-30-video-modal .modal-close').on('click', closeModal);

    $('#offer-30-video-modal .modal-wrapper').on('click', () => {
        closeModal();
    });

    $('#offer-30-video-modal .modal').on('click', (e) => {
        e.stopPropagation();
    });

    function closeModal() {
        $('#offer-30-video-modal video')[0]?.pause();
        $('#offer-30-video-modal').fadeOut(300);
        $('body').css('overflow', 'auto');
    }

    // Tooltip handlers for comparison table properties
    const $propertyElements = $('.offer-30-packages-comparison td.property');

    $propertyElements.on('click', function (e){
        $('.expand-button').trigger('click');
        openTooltip($(this).find('.tooltip'), e);
    });

    if(window.innerWidth > 992){
        $propertyElements.on('mouseover', function (e){
            openTooltip($(this).find('.tooltip'), e);
        });
    }

    $propertyElements.on('mouseout', function (event){
        var e = event.toElement || event.relatedTarget;
        if ($(e).hasClass('tooltip-open') || $(e).parents().hasClass('tooltip-open') ) {
            return;
        }

        $('.tooltip').removeClass('open')
        $('.tooltip-open').remove();
    });

    function openTooltip($tt, event) {
        if(event.type === 'click' && $(event.target).hasClass('play-icon') && $tt.hasClass('open')) {
            $('.tooltip-video').trigger('click');
            return;
        }

        if($tt.hasClass('open')) return;
        $('.tooltip-open').remove();
        $('.tooltip').removeClass('open');
        $tt.addClass('open');

        const ID = $tt.parent().data('id');
        const tooltip_content = $tt.data('tooltip-content');
        const tooltip_video = $tt.data('video');
        const $tooltip = $(`${tooltip_content}`);
        $tt.append($tooltip);
        $tooltip.attr('data-id', ID);

        $tooltip.find('.tooltip-video').on('click', function (){
            $('#offer-30-video-modal video').attr('src', tooltip_video).attr('controls', 'controls');
            $('#offer-30-video-modal video')[0].play();
            $('#offer-30-video-modal').fadeIn(300);
            $('body').css('overflow', 'hidden');
            $('.tooltip-open').remove();
            $tt.removeClass('open');
        });
    }

})(jQuery);
